import { useState, useEffect, useCallback } from "react";
import { REGISTRATION_RULES_API, fetchWithAuth } from "../utils/api";

/**
 * Hook to fetch and manage available age groups from registration rules
 */
export function useAgeGroups() {
  const [ageGroups, setAgeGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAgeGroups = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch registration rules to get age groups
      const rulesData = await fetchWithAuth(REGISTRATION_RULES_API);
      
      // Extract age groups from registration rules
      const ageGroupsList = rulesData?.ageGroups || [];
      
      // Normalize age groups to get labels
      const normalizedAgeGroups = ageGroupsList
        .map(group => group.label || group.name)
        .filter(label => label && label.trim() !== "")
        .filter((label, index, arr) => arr.indexOf(label) === index) // Remove duplicates
        .sort(); // Sort alphabetically
      
      console.log('Fetched age groups from registration rules:', normalizedAgeGroups);
      setAgeGroups(normalizedAgeGroups);
    } catch (err) {
      console.error("Error fetching age groups:", err);
      setError(err.message || "Failed to load age groups");
      setAgeGroups([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load age groups on mount
  useEffect(() => {
    fetchAgeGroups();
  }, [fetchAgeGroups]);

  return {
    ageGroups,
    loading,
    error,
    refetchAgeGroups: fetchAgeGroups
  };
}


